class PlpPlacementModal extends HTMLElement {
    constructor() {
        super();

        this.products = this.querySelectorAll('.plp-placement-modal__product');
        this.overlayProductButton = this.querySelectorAll('.image__overlay-button');

        this.productHover()
    }

    productHover(){

        const _this = this;

        this.products.forEach(product => {

            product.addEventListener("mouseout", (event) => {

                let currProductId = product.dataset.productId;
                let currProductToolTip = _this.querySelector(`.image__overlay-button[data-product-id="${currProductId}"]`);
                currProductToolTip.classList.remove('product--hover');
            });

            product.addEventListener("mouseover", (event) => {

                let currProductId = product.dataset.productId;
                let currProductToolTip = _this.querySelector(`.image__overlay-button[data-product-id="${currProductId}"]`);
                currProductToolTip.classList.add('product--hover');
            });
            
        });
    }
}

customElements.define('plp-placement-modal', PlpPlacementModal);

class PLPModalTrigger extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', this.openModal.bind(this));
    }

    openModal() {

        const modal = this.dataset.placementModal;

        MicroModal.show(`${modal}`, {
            onShow: () => {
                console.log('modal show');
                document.querySelector('body').classList.add('no-scroll');
            },
            onClose: () =>{
                console.log('modal close');
                document.querySelector('body').classList.remove('no-scroll');
            }
        });
    }
}

customElements.define('plp-modal-trigger', PLPModalTrigger);